import React from "react";
import {
  Image,
  ImageStyle,
  Linking,
  Platform,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import { styles, ids } from "./Style";
import commonStyle from "../../assets/styles/common-style";
import {
  CALL_ICON,
  EMAIL_ICON,
  FAX_ICON,
  CLAIM_PAEG_IMAGE,
} from "../../resources/IMAGES";
import ContactCard, { CardType } from "../ContactCard/ContactCard";
import { displayPhoneFormatter } from "@lib/utilities/Formatters";
import { isTablet } from "react-native-device-info";
import {
  description,
  email,
  fax,
  labelText,
  phoneNumber,
} from "../../resources/strings";

const ContentView = () => {
  const contactCards = [
    {
      type: CardType.Phone,
      icon: CALL_ICON,
      title: labelText.commonLabels.callUs,
      content: displayPhoneFormatter(phoneNumber),
      onPress: () => Linking.openURL(`tel:${phoneNumber}`),
      isFaded: false,
    },
    {
      type: CardType.Email,
      icon: EMAIL_ICON,
      title: labelText.commonLabels.emailUs,
      content: email,
      onPress: () => Linking.openURL(`mailto:${email}`),
      isFaded: false,
    },
    // {
    //   type: CardType.Fax,
    //   icon: FAX_ICON,
    //   title: labelText.commonLabels.faxUs,
    //   content: displayPhoneFormatter(fax),
    //   isFaded: true,
    // }, fax tile hidden as per business requirement
  ];
  const { height, width } = useWindowDimensions();

  const getOrientationStyle = (): ImageStyle => {
    return {
      transform: [{ scale: isTablet() && height > width ? 0.9 : 1 }],
      marginLeft:
        isTablet() && height > width ? "-7%" : Platform.OS == "ios" ? -7 : 0,
    };
  };
  const HeadingSection = () => (
    <View style={[styles.yourAgenInfo]} dataSet={{ media: ids.yourAgenInfo }}>
      <Text style={[styles.headingText]} dataSet={{ media: ids.headingText }} testID={`claim-page-header`}>
        {labelText.claim.heading1}
        {"\n"}
      </Text>
      <Text style={[styles.bodyText]} dataSet={{ media: ids.bodyText }} testID={`claim-page-description`}>
        {description.claim.description1}
      </Text>
      <View style={styles.graphicArea}>
        <View style={styles.agentImage}>
          <Image
            resizeMode="contain"
            style={[styles.contactAgent, getOrientationStyle()]}
            source={CLAIM_PAEG_IMAGE}
            testID={`claim-page-image`}
          />
        </View>
      </View>
    </View>
  );
  return (
    <View
      style={[styles.contactAgentList]}
      dataSet={{ media: ids.contactAgentList }}
    >
      <View style={[commonStyle.styles.rowFlex, styles.claimDetail]}>
        <HeadingSection />
        <View style={[styles.contactInfo]} dataSet={{ media: ids.contactInfo }} testID="claims-page-contact-cards">
          {contactCards.map((card, index) => (
            <ContactCard
              key={index}
              type={card.type}
              icon={card.icon}
              title={card.title}
              content={card.content}
              onPress={card.onPress}
              isFaded={card.isFaded}
              page={"claims"}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

export default ContentView;
